module.exports = __webpack_public_path__ + "img/btn-notice.d9faeecd.png";